/* CTN bike builder product template controller.

   Colour is the only thing the page selects. It is chosen in the hero dock,
   and drives the hero image, the colour name, the price and the builder link.

   Size and wheel selection were removed when the choice cards became display
   only. They had no control left to drive them, so they sat on a hardcoded
   default, which made the geometry table look as though M were recommended.
   The builder makes those choices now.

   Anything marked data-ctn-readonly is display only.
   Sections opt in with data attributes, so any section can be absent.
   House style: no em dashes or en dashes in this file. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var data = {};
    var node = document.getElementById('ctn-bike-data');
    if (node) {
      try { data = JSON.parse(node.textContent) || {}; } catch (e) { data = {}; }
    }

    /* Build the colour list from the interactive swatches only. The read only
       swatches in the choice cards carry no colour data. */
    var colours = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-ctn-colour]:not([data-ctn-readonly])'),
      function (el) {
        var i = Number(el.getAttribute('data-ctn-colour'));
        if (colours[i]) return;
        colours[i] = {
          name: el.getAttribute('data-ctn-colour-name') || '',
          key: el.getAttribute('data-ctn-colour-key') || '',
          premiumCents: Number(el.getAttribute('data-ctn-colour-premium') || 0),
          image: el.getAttribute('data-ctn-colour-image') || ''
        };
      }
    );

    var state = { colour: 0 };

    var money;
    try {
      money = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: data.currency || 'AUD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    } catch (e) {
      money = { format: function (n) { return '$' + n; } };
    }

    function fmt(cents) { return money.format(Math.round((cents || 0) / 100)); }

    function currentColour() { return colours[state.colour] || {}; }

    function priceCents() {
      return (data.floorPriceCents || 0) + (currentColour().premiumCents || 0);
    }

    function isBasePrice() {
      return !(currentColour().premiumCents || 0);
    }

    function each(selector, fn) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), fn);
    }

    function setBind(name, html) {
      each('[data-ctn-bind="' + name + '"]', function (el) { el.innerHTML = html; });
    }

    /* Hero cross fade between two stacked img elements */
    var heroLayers = document.querySelectorAll('[data-ctn-hero-layer]');
    var activeLayer = 0;

    function swapHero(index) {
      var image = (colours[index] || {}).image;
      if (!image || heroLayers.length < 2) return;
      var showing = heroLayers[activeLayer];
      var next = heroLayers[activeLayer === 0 ? 1 : 0];
      if (next.getAttribute('src') === image) return;
      next.setAttribute('src', image);
      next.classList.remove('is-out');
      showing.classList.add('is-out');
      activeLayer = activeLayer === 0 ? 1 : 0;
    }

    function buildHref() {
      if (!data.modelId) return null;
      var url = data.builderBase + '?model=' + encodeURIComponent(data.modelId) + '&from=winspace';
      if (data.flow) url += '&flow=' + encodeURIComponent(data.flow);
      if (currentColour().key) url += '&colour=' + encodeURIComponent(currentColour().key);
      return url;
    }

    function render() {
      var colour = currentColour();
      var premium = colour.premiumCents || 0;
      var premiumTag = premium ? ' <span class="ctn-plus">+' + fmt(premium) + '</span>' : '';

      setBind('colourName', (colour.name || '').toUpperCase() +
        (premium ? ' <span class="ctn-prem">+' + fmt(premium) + '</span>' : ''));

      setBind('sizeColour', (colour.name || '') + premiumTag);
      setBind('choiceColour', (colour.name || '') + premiumTag);
      setBind('barColour', colour.name || '');

      /* One price string across the hero, buy bar and finale. It reads as a
         From price until a colour premium adds cost. */
      var priceText = isBasePrice() ? 'From ' + fmt(data.floorPriceCents) : fmt(priceCents());
      setBind('heroPrice', priceText);
      setBind('finalePrice', priceText.toLowerCase());
      setBind('barPrice', priceText);

      each('[data-ctn-colour]:not([data-ctn-readonly])', function (el) {
        el.classList.toggle('is-on', Number(el.getAttribute('data-ctn-colour')) === state.colour);
      });

      var href = buildHref();
      if (href) {
        each('[data-ctn-cta]', function (el) {
          if (el.tagName === 'A') el.setAttribute('href', href);
        });
      }
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var el = target.closest('[data-ctn-colour]');
      if (!el || el.hasAttribute('data-ctn-readonly')) return;
      state.colour = Number(el.getAttribute('data-ctn-colour'));
      swapHero(state.colour);
      render();
    });

    var bar = document.querySelector('[data-ctn-buybar]');
    if (bar) {
      var onScroll = function () {
        bar.classList.toggle('is-show', window.scrollY > window.innerHeight * 0.75);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    render();
  });
})();
